import { addHours, format, isBefore, isEqual } from 'date-fns'

type ICouponValidation = {
  id: string;
  name: string;
  discount_type: number;
  discount_value: string;
  affiliate_id: string | null;
  commission?: string;
  limit_date: string;
  limit_quantity: number;
  product_limit: number;
  min_purchase_value: string;
  active: boolean;
  client_id: string | null;
  times_used: number;
  createdAt?: string;
  updatedAt?: string;
  message?: string;
}

export default class General {
  static textLimit(word: string, max: number) {
    if(word?.length > max) {
      return `${word.substring(0, max - 3)}...`;
    }
    return word;
  }

  static base64ToBlob(base64Data: string, contentType: string) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  static formatCurrency(value: number) {
    const currency = new Intl.NumberFormat(
      'en-US',
      {
        currency: 'USD',
        maximumFractionDigits: 2,
      },
    )
    return currency.format(value)
  }

  static compareDateUTCISOIsLessThanOrEqualToToday(dateISO: string) {
    const currentDate = format(new Date(), 'yyyy-MM-dd');
    const date = format(addHours(dateISO, 3), 'yyyy-MM-dd');
    return isBefore(currentDate, date) || isEqual(currentDate, date);
  }

  static couponValidation(
    coupon: ICouponValidation | null,
    totalPrice: number,
    productQuantity: number,
    affiliateId?: string,
  ) {
    const validation = {
      couponUnavailable:
        coupon?.affiliate_id !== null &&
        coupon?.affiliate_id !== undefined &&
        coupon?.affiliate_id !== affiliateId,
      inactiveCoupon: coupon ? !coupon?.active : true,
      expiredCoupon: coupon 
        ? !this.compareDateUTCISOIsLessThanOrEqualToToday(coupon?.limit_date)
        : true,
      purchaseBelowTheMinimumValue:
        coupon ? totalPrice < parseFloat(coupon?.min_purchase_value) : true,
      totalValueGreaterThanTheMaximumDiscountValue:
          coupon?.discount_type === 1 &&
          totalPrice - parseFloat(coupon?.discount_value) <= 0,
      nonExistentCoupon: !!coupon?.message,
      couponLimitReached:
        coupon ? coupon.times_used >= coupon.limit_quantity  : true,
      productLimitReached:
        coupon ? coupon.product_limit < productQuantity : true,
    }

    return {
      ...validation,
      validatedCoupon:
        !validation.couponUnavailable
        && !validation.inactiveCoupon
        && !validation.expiredCoupon
        && !validation.purchaseBelowTheMinimumValue
        && !validation.totalValueGreaterThanTheMaximumDiscountValue
        && !validation.nonExistentCoupon
        && !validation.productLimitReached
    }
  }
}